module.exports = "/_next/static/images/step1Illustration-36c59815fc678b277a31ad2670977c63.svg";